import { getIsNew } from '@monofront/business/utils';
import { useProduct } from '../ProductCard';
import New from '../../../visuals/Pictograms/New';
import { useTranslations } from 'next-intl';

export const ProductPictograms: React.FC = () => {
  const product = useProduct();
  const tCatalog = useTranslations('Catalog');

  if (!product) {
    return null;
  }

  const isNew = getIsNew(product.tags);

  if (!isNew) {
    return null;
  }

  return (
    <div className="tw-relative !tw-m-0 tw-h-0 tw-grid-area-[pictos]">
      <New
        aria-label={tCatalog('new')}
        UNSAFE_className="tw-absolute tw-bottom-0"
      />
    </div>
  );
};
